export const IconBuger = () => (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3.5" y="5" width="18" height="2" rx="1" fill="#6C7084" />
        <rect x="3.5" y="17" width="15" height="2" rx="1" fill="#6C7084" />
        <rect x="3.5" y="11" width="12" height="2" rx="1" fill="#6C7084" />
    </svg>
);
